import React from "react";
import { Modal, Button } from "react-bootstrap";
import { EMPTY, NONE } from "../../../configurations/Constants";
import { WELL_CONNECTION_DETAILS_UPDATED } from "../../../configurations/MessageConstants";

const SuccessPopup = ({ show, onHide, wellId, meterId, accountId }) => {
  return (
    <Modal size="md" show={show} centered onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>
          Well Details Updated
          <i
            className="fa fa-check field-transfer-success-icon"
            aria-hidden="true"
          ></i>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="text-muted">
          {WELL_CONNECTION_DETAILS_UPDATED} <strong>{wellId}</strong>.
        </p>

        <p className="text-muted m-0">
          <strong>Meter ID:</strong> {meterId === EMPTY ? NONE : meterId}
        </p>
        <p className="text-muted m-0">
          <strong>Account ID:</strong> {accountId === EMPTY ? NONE : accountId}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessPopup;
